export type FunctionCardDef = {
    no: string;
    titleKey: string;
    descKey: string;
};

export const FUNCTION_SECTION_CARDS: {
    basic: FunctionCardDef[];
    premium: FunctionCardDef[];
} = {
    basic: [
        {
            no: '01',
            titleKey: 'function-section.cards.01.title',
            descKey: 'function-section.cards.01.description',
        },
        {
            no: '02',
            titleKey: 'function-section.cards.02.title',
            descKey: 'function-section.cards.02.description',
        },
        {
            no: '03',
            titleKey: 'function-section.cards.03.title',
            descKey: 'function-section.cards.03.description',
        },
        {
            no: '04',
            titleKey: 'function-section.cards.04.title',
            descKey: 'function-section.cards.04.description',
        },
        {
            no: '05',
            titleKey: 'function-section.cards.05.title',
            descKey: 'function-section.cards.05.description',
        },
        {
            no: '06',
            titleKey: 'function-section.cards.06.title',
            descKey: 'function-section.cards.06.description',
        },
    ],
    premium: [
        {
            no: '07',
            titleKey: 'function-section.cards.07.title',
            descKey: 'function-section.cards.07.description',
        },
        {
            no: '08',
            titleKey: 'function-section.cards.08.title',
            descKey: 'function-section.cards.08.description',
        },
        {
            no: '09',
            titleKey: 'function-section.cards.09.title',
            descKey: 'function-section.cards.09.description',
        },
    ],
};
